/* import __COLOCATED_TEMPLATE__ from './convert-to-ticket-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();